import { getAllProducts, getAuthProducts } from "@/api/apps";
import i18n from "@/lang";
import { merge } from "lodash";

export default {
  namespaced: true,
  state: {
    authProducts: [],
    productsData: [],
    solutionsData: []
  },
  mutations: {
    SET_AUTH_PRODUCTS: (state, data) => {
      state.authProducts = data || [];
    },
    SET_ALL_PRODUCTS: (state, data) => {
      state.productsData = data.productsData;
      state.solutionsData = data.solutionsData;
    }
  },
  actions: {
    async getAuthProducts({ commit }) {
      const res = await getAuthProducts();
      const { data: authProductsData } = res || {};
      authProductsData.data &&
        authProductsData.data.forEach(item => {
          if (item.groupName === "智库") {
            const authProducts = item.children || [];
            commit("SET_AUTH_PRODUCTS", authProducts);
          }
        });
    },

    async getAllProducts({ commit }) {
      let [{ data: allProductsData }, { data: data2 }] = await Promise.all([
        getAllProducts(),
        i18n.locale === 'en' && getAllProducts({}, { language: 'zh_CN' })
      ]);

      let productsData = [];
      let solutionsData = [];
      if (allProductsData.data.length) {
        const changeName = items => {
          items.forEach(item => {
            if (item.groupName) {
              item.groupName_zh_CN = item.groupName
            }
            if (item.children) {
              changeName(item.children)
            }
            if (item.productName) {
              item.productName_zh_CN = item.productName
            }
            if (item.productList) {
              changeName(item.productList)
            }
          })
        };
        if (i18n.locale === 'en') {
          changeName(data2.data)
          allProductsData = merge(data2.data, allProductsData.data);
        } else {
          changeName(allProductsData.data)
          allProductsData = allProductsData.data
        }
        // console.log('getAllProducts', allProductsData);

        allProductsData.forEach(item => {
          if (item.groupName === "智库") {
            productsData = item.children || [];
          }
          if (item.groupName === "智策") {
            solutionsData = item.children || [];
          }
        });
      }
      commit("SET_ALL_PRODUCTS", { productsData, solutionsData });
    }
  }
};
